import Vue from 'vue'
import VueMeta from 'vue-meta'
import { sync } from 'vuex-router-sync'
import router from '@/router'
import store from '@/store'
import '@/plugins'
import { i18n } from '@/plugins/i18n'

import BootstrapVue from 'bootstrap-vue'
const App = () => import('@/App.vue')

sync(store, router)

Vue.use(BootstrapVue)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
})
Vue.config.productionTip = false

const NavbarStore = {
  showNavbar: false,
}

Vue.mixin({
  data() {
    return {
      NavbarStore,
    }
  },
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {
    App,
  },
  template: '<App />',
})
